"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAllProjectsKey = createAllProjectsKey;

function createAllProjectsKey() {
  return ['all-projects'];
}